<template>
  <div class="basketpage page">
    
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> - <router-link :to="{ name: 'BasketPage' }">Warenkorb</router-link>
          <h1>Warenkorb</h1>
        </div>
      </div>      
    </div>

    <div class="columns" v-if=" user.basket.length < 1">
      <div class="column">
        <h3>Ihr Warenkorb ist leer</h3>
      </div>      
    </div>


    <div class="columns">

      <div class="column" >
        <div class="cart-product-link" v-for="(product, i) in user.basket" :key="i" :sync="user.basket">
           <router-link  :to="{ name: 'DetailPage', params: { pg: product.pg, artnr: product.artnr } }">
                <div class="prod-img-container">
                  <img v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                  <img class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.png':'/upload/product-images/platzhalter_artikelohnefoto.svg' ">
                </div>
            <div class="p-name p-detail">{{product.bez1}} <span v-if="product.vari">{{product.vari}}</span></div>
            </router-link>
            <div class="p-vpe p-detail">{{product.fmng}} {{product.me}} {{ product.vpe != "lose" ? product.vpe : '' }}</div>
            <div class="p-detail">x</div>
            <div class="p-count p-detail"><i class="icon icon-minus" v-on:click="minus(product)"></i> <input type="number" :value="product.count" v-on:change="changeCount(product)"> <i class="icon icon-plus" v-on:click="plus(product)"></i> </div>
            <div class="p-notes p-detail"><textarea v-on:change="saveNotes(product)" v-model="user.basket[i].notes">{{product.notes}}</textarea></div>
            <div class="p-remove p-detail"><i class="icon icon-remove" v-on:click="removeFromBasket(i)"></i></div>
        </div>
      </div>
    </div>

    <div class="columns" v-if=" user.basket.length > 0">
      <div class="column">
        <button class="button" v-on:click="go2checkout">Weiter zur Bestellung</button>
      </div>      
    </div>

  </div>
</template>
<script>
import products from '../data/etar2.json';
  
export default {
    name: 'BasketPage',
    data: function(){
      return {
         cartproducts: []
         }
    },
    
    created: function(){},
    mounted: function(){},
    computed: {
        user () {
            return this.$store.state.authentication.user
        },  
    },        
    methods: {
      go2checkout(){
        //console.log('go2checkout');
       this.updateCartonServer();
        this.$router.push('/checkout');
      },
      
      
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
     saveNotes(p){
       this.$store.state.authentication.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0].notes = p.notes
       this.updateCartonServer();
       //console.log('save notes');
       //console.log( this.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0].notes );
     },
     minus(p){
       p.count = --p.count < 1 ? 1 : p.count;
       this.$store.state.authentication.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0].count = p.count
       //console.log( this.$store.state.user.basket );
       this.updateCartonServer();
     },
     plus(p){
       p.count++;
       this.$store.state.authentication.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0].count = p.count
       //console.log( this.$store.state.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0] );
       this.updateCartonServer();
     },
     changeCount(p) {
       p.count = p.count < 1 ? 1 : p.count;
       //console.log('changeCount ' + p.count );
       this.$store.state.authentication.user.basket.filter((pr)=>{ return pr.artnr == p.artnr })[0].count = p.count
       this.updateCartonServer();
     },
     removeFromBasket(i) {
       this.$store.state.authentication.user.basket.splice(i,1)
       this.updateCartonServer();
     },


     updateCartonServer(){
        const basket = this.user.basket;
        const { dispatch } = this.$store;
        dispatch('basket/update', { basket });
     },



    }
}
</script>
<style >
  .cart-product-link { display: flex; align-items: center; width: 100%; flex-wrap: wrap; border-top: 1px solid #ddd; margin: 0;}
  .cart-product-link a { width: 30%; max-width: 20em; display: flex; align-items: center; text-decoration: none !important; border: 0 solid green; }
  .cart-product-link:before { display: none; }
  .cart-product-link .prod-img-container { width: 6em; overflow: hidden; }
  .cart-product-link a .prod-img-container img { transform: scale(1.01); transition: transform 0.4s ease-in-out }
  .cart-product-link a:hover .prod-img-container img { transform: scale(1.1) }

  .cart-product-link .p-detail { padding: 0.9333333em;  color: #00853e; border: 0 solid red; }
  .cart-product-link .p-detail.p-name { font-weight: bold; width: 13em; min-width: 10em;  }
  .cart-product-link .p-detail.p-vpe {  width: 10em; min-width: 10em;  }
  .cart-product-link .p-detail.p-name span { font-weight: normal; display: block;  }
  .cart-product-link .p-detail.p-count { font-weight: bold; color: #dc1200; display: flex;  }
  .cart-product-link .p-detail.p-notes { width: 30%; min-width: 18em; }
  .cart-product-link .p-detail.p-notes textarea { width: 100%; border: 1px solid #ddd; border-radius: 3px; padding: 0.43333333em; outline: 0 !important; transition: border-color 0.2s ease-in-out; }
  .cart-product-link .p-detail.p-notes textarea:focus { border: 1px solid #00853e; }
  .cart-product-link input[type="number"] { width: 3em; text-align: right; margin: 0 0.2333333em }
  .cart-product-link .p-detail.p-remove { width: 3em; }
  
  .basketpage .button { background: #00853e; color: #fff; border: 0; padding: 0.63333em 2.73333333em; border-radius: 3px; text-align: center; width: auto; margin: 0; cursor: pointer; }
  .basketpage .button { transform: scale(1.01); transition: transform 0.4s ease-in-out; }
  .basketpage .button:hover { transform: scale(1.05) }
</style>